(function () {
  const CACHE_KEY = 'discount_sync_v1';
  const CACHE_DURATION = 5 * 60 * 1000;
  let lastEnteredCode = '';

  async function getDiscounts(apiUrl) {
    try {
      const cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) {
        const { data, ts } = JSON.parse(cached);
        if (Date.now() - ts < CACHE_DURATION) return data;
      }
      const res = await fetch(apiUrl);
      if (!res.ok) return null;
      const json = await res.json();
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ data: json.discounts, ts: Date.now() }));
      return json.discounts;
    } catch {
      return null;
    }
  }

  // Capture discount code when APPLY is clicked
  document.addEventListener('click', function (e) {
    var button = e.target.closest('.cart-discounts--button');
    if (button) {
      var root = button.closest('cart-discounts');
      var input = root && root.querySelector('.cart-discounts--input');
      if (input) lastEnteredCode = input.value.trim();
    }
  }, true);

  // Watch for error divs becoming visible
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (
        m.type === 'attributes' &&
        m.attributeName === 'hidden' &&
        m.target.classList.contains('cart-discounts--error') &&
        !m.target.hasAttribute('hidden')
      ) {
        replaceErrorIfMatch(m.target);
      }
    });
  });
  observer.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['hidden'] });

  async function replaceErrorIfMatch(errorDiv) {
    var progressEl = document.querySelector('discount-progress');
    if (!progressEl) return;

    var cartTotal = parseInt(progressEl.dataset.cartTotal, 10);
    var cartDollars = cartTotal / 100;
    var apiUrl = progressEl.dataset.apiUrl;

    var discounts = await getDiscounts(apiUrl);
    if (!discounts) return;

    // Check if entered code matches one of our known discounts
    var enteredCode = lastEnteredCode.toLowerCase();
    var matchedDiscount = discounts.find(function (d) {
      return d.codes.some(function (c) { return c.toLowerCase() === enteredCode; });
    });

    if (!matchedDiscount) return; // not one of our codes — show default error
    if (!matchedDiscount.minimum || matchedDiscount.minimum.type !== 'subtotal') return;
    if (cartDollars >= matchedDiscount.minimum.amount) return; // cart meets minimum

    var remaining = (matchedDiscount.minimum.amount - cartDollars).toFixed(2);
    var symbol = matchedDiscount.minimum.currencyCode === 'USD' ? '$' : matchedDiscount.minimum.currencyCode + ' ';

    var errorText = errorDiv.querySelector('.cart-discounts--error-text');
    if (errorText) {
      errorText.textContent = 'Spend ' + symbol + remaining + ' more to unlock your discount!';
    }
  }

  // Invisible custom element — provides cart data from Liquid
  class DiscountProgress extends HTMLElement {
    connectedCallback() {
      this.style.display = 'none';
      getDiscounts(this.dataset.apiUrl);
    }
  }

  if (!customElements.get('discount-progress')) {
    customElements.define('discount-progress', DiscountProgress);
  }
})();
